import '@traceio-org/auth-ui/styles.css';
import './app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { loadHubConfig } from './app/config';
import { isFramed } from './app/framing';
import { HubProvider } from './app/context';
import { createHubDependencies } from './app/deps';
import { ConfigErrorPage, FramedPage } from './pages/ShellPages';
import { createHubRoutes } from './routes';

const container = document.getElementById('root');
if (!container) throw new Error('account-hub: #root is missing from index.html');

// The favicons (Obsidian mark on light browser chrome, Peel on dark) are linked in index.html; nothing is set
// here, so the per-scheme links are not overwritten with the Obsidian mark that dark tab bars hide.

const root = createRoot(container);
const result = loadHubConfig(import.meta.env, { dev: import.meta.env.DEV });

if (isFramed()) {
  root.render(
    <StrictMode>
      <FramedPage />
    </StrictMode>,
  );
} else if (!result.ok) {
  console.error('account-hub: invalid configuration', result.errors);
  root.render(
    <StrictMode>
      <ConfigErrorPage errors={result.errors} />
    </StrictMode>,
  );
} else {
  for (const warning of result.warnings) console.warn(`account-hub: ${warning}`);
  const deps = createHubDependencies(result.config);
  const router = createBrowserRouter(createHubRoutes(deps));
  root.render(
    <StrictMode>
      <HubProvider deps={deps}>
        <RouterProvider router={router} />
      </HubProvider>
    </StrictMode>,
  );
}
